// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/gate_close_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/gate_close_model.proto.
 */
export const file_bffuser_v1_gate_close_model: GenFile = /*@__PURE__*/
  fileDesc("CiFiZmZ1c2VyL3YxL2dhdGVfY2xvc2VfbW9kZWwucHJvdG8SCmJmZnVzZXIudjEiiwEKEUdhdGVDbG9zZUZyb250aWVyEioKD25leHRfY2xvc2VfZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSFwoPbmV4dF9jbG9zZV9rb21hGAIgASgFEjEKDW5leHRfY2xvc2VfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_google_protobuf_timestamp, file_google_type_date]);

/**
 * GateCloseFrontier は応答を作った時刻でのゲートクローズ (GC) の境界を表す。
 * backend の valueobject.GateCloseFrontier を wire に写したもので、画面を跨いで共通に使う。
 * Mirrors internalapi.v1.GateCloseFrontier。
 *
 * コマを (受渡日, コマ番号) の順に並べると、GC 済みのコマは常に先頭から連続する。
 * next_close_* はまだ GC を迎えていない最初のコマで、それより前のコマはすべて GC 済み
 * (編集不可)、それ以降はすべて未済。前日 23:00 / 23:30 に翌日のコマ 1 / 2 が GC 済みに
 * なる日跨ぎも backend が解決済みなので、frontend は「今日」や GC の余裕時間 (1 時間) を
 * 知らずに、コマと next_close_* の比較だけでロックを判定できる (`~/models/gateClose`)。
 *
 * next_close_date は「今日」ではない (22:30 JST 以降は翌日になる)。今日の代わりに使わない。
 *
 * @generated from message bffuser.v1.GateCloseFrontier
 */
export type GateCloseFrontier = Message<"bffuser.v1.GateCloseFrontier"> & {
  /**
   * まだ GC を迎えていない最初のコマの受渡日 (JST のカレンダー日)。
   *
   * @generated from field: google.type.Date next_close_date = 1;
   */
  nextCloseDate?: Date;

  /**
   * そのコマ番号 (1-48)。
   *
   * @generated from field: int32 next_close_koma = 2;
   */
  nextCloseKoma: number;

  /**
   * そのコマが GC を迎える時刻 (= 次の GC 締切)。この時刻ちょうどで GC 済みになる。
   *
   * @generated from field: google.protobuf.Timestamp next_close_at = 3;
   */
  nextCloseAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.GateCloseFrontier.
 * Use `create(GateCloseFrontierSchema)` to create a new message.
 */
export const GateCloseFrontierSchema: GenMessage<GateCloseFrontier> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_gate_close_model, 0);

